import {get, derived} from "svelte/store";
import {organizationStore} from "../organizations/organizations";
import {userStore} from "../users/users";

export let organizationWithoutAdminEh3 = derived([userStore, organizationStore], ([users, organizations]) => {
    return organizations.filter(org => !(getUsersForOrganization(org).some(user => (user.admin && user.ehLevel === "EH3"))))
})

export const summaryPageState = derived(organizationWithoutAdminEh3, organizations => {
    return organizations.length === 0
})

export function getUsersForOrganization(organization) {
    return get(userStore).filter(user => user.allOrganizations || user.organizations.find(org => org === organization.companyId))
}